// Author TianHaiQing
// Date 2025-04-03 09:21:59

import * as model from "@/model/em/inspection/InspectionScheduleTimeoutRecordModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.InspectionScheduleTimeoutRecord(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_INSPECTION_URL,
    })
    .buildStore()
